/*
  This piece of Redux middleware is used to route asynchronously route API requests to the Server 
  in response to Redux actions. To use this service simply create a action with the following object 
  assigned to the "meta" field of the action:

  meta : {
    path: "A string containing the path to be used (in addition to base URL (e.g. /users). Required."
    method: The Http method to be used for the service call. Defaults to GET
    body: For create/update operations the JSON body to be sent to the server. 
  } 
*/
import { fetch, apiBaseUrl } from "../util";

const apiService = store => next => action => {
    if (!action.meta || !action.meta.async) {
        const result = next(action);
        return result;
    }

    const { path, method = "GET", body } = action.meta;

    if (!path) {
        throw new Error(`'path' not specified for async action ${action.type}`);
    }

    store.dispatch({
        type: `${action.type}_STARTED`
    });

    const url = `${apiBaseUrl}${path}`;

    fetch(url, method, body)
        .then(res => handleResponse(res, action, next))
        .catch(err => handleErrors(err, action, next));
};

export default apiService;

function handleErrors(err, action, next) {
    next({
        type: `${action.type}_FAILED`,
        payload: err
    });
}

function handleResponse(res, action, next) {
    next({
        type: `${action.type}_COMPLETED`,
        payload: res
    });
}



// WEBPACK FOOTER //
// ./middleware/apiService.js